import React, {useState} from 'react';
import {objToArrayKeyValue} from '../../utils';
import {skillType} from '../../utils/constants';
import SkillDropdown from '../common/SkillDropdown';
import Button from '../ui/Button';
import ChipContainer from '../ui/chip/ChipContainer';

const getSkillTypeNameByType = (type) =>
  +type === 1 ? 'technicalSkills' : 'interpersonalSkills';

const SelectSkillForm = ({jobFormHook, skillList}) => {
  const {setValue: setFormValue, getValues: getFormValues, watch} = jobFormHook;

  /**
   * @example currentSkill
   * {
   *    1: 'uuid', // skillType : skillId
   *    2: 'uuid',
   * }
   */
  const [currentSkill, setCurrentSkill] = useState({
    1: null,
    2: null,
  });

  const handleAddSkill = (skillType) => {
    const skillTypeName = getSkillTypeNameByType(skillType);
    const formSkills = getFormValues(skillTypeName) || [];

    const isSkillAlreadyAdded = formSkills.find(
      (id) => id === currentSkill[skillType].value,
    );

    if (isSkillAlreadyAdded) return;

    setFormValue(skillTypeName, [...formSkills, currentSkill[skillType].value]);

    setCurrentSkill((prev) => ({
      ...prev,
      [skillType]: null,
    }));
  };

  const handleRemoveSkill = (deleteSkillId, deleteSkillType) => {
    const skillTypeName = getSkillTypeNameByType(deleteSkillType);
    const formSkills = getFormValues(skillTypeName) || [];

    setFormValue(
      skillTypeName,
      [...formSkills].filter((id) => id !== deleteSkillId),
    );
  };

  const selectedSkills = (selectedSkillIds) =>
    (selectedSkillIds || []).map((item) => ({
      id: item,
      label: skillList[item],
    }));

  const techSkills = selectedSkills(watch('technicalSkills'));
  const interpersonalSkills = selectedSkills(watch('interpersonalSkills'));

  return (
    <div className="grid grid-cols-2 gap-7 w-full">
      {objToArrayKeyValue(skillType).map(([skillType, skillName]) => (
        <div className="flex flex-col gap-2" key={skillType}>
          <label>{skillName} skills</label>
          <div className="flex gap-2">
            <SkillDropdown
              className="w-full bg-white"
              name={skillName.toLowerCase()} // dynamic name, incase of adding of more skill type
              type={+skillType}
              optionsWithId
              onChange={(value) => {
                setCurrentSkill((prev) => ({
                  ...prev,
                  [skillType]: value,
                }));
              }}
              value={
                currentSkill[skillType]
                  ? {
                      value: currentSkill[skillType],
                      label: skillList[currentSkill[skillType].value],
                    }
                  : null
              }
            />
            <Button
              className="self-center px-5 py-3"
              onClick={() => handleAddSkill(+skillType)}
            >
              Add
            </Button>
          </div>
          <ChipContainer
            className="pt-1"
            data={+skillType === 1 ? techSkills : interpersonalSkills}
            color="bg-gray-200"
            remove={(skillId) => handleRemoveSkill(skillId, skillType)}
          />
        </div>
      ))}
    </div>
  );
};

export default SelectSkillForm;
